

$('.faq-search-form').on('submit', function (e) {
  e.preventDefault();
  const searchQuery = $('.faq-search-form input').val().toLowerCase();
  performSearch(searchQuery);
});

$('.faq-search-form input').on('keyup', function (e) {
  e.preventDefault();
  const searchQuery = $('.faq-search-form input').val().toLowerCase();
  performSearch(searchQuery);
});

function hideEmptyState (searchQuery) {
  $('.faq-no-results').hide();
}

function showEmptyState (searchQuery) {
  $('.faq-no-results .query').html(searchQuery);
  $('body').addClass('search-active');
  $('.faq-no-results').show();
}


function clearSearch () {
  $('.accordion__section-heading').show();
  $('.accordion-panel').show();
  $('.faq-no-results').hide();
  $('body').removeClass('search-active');
  $('.results-list').hide();

}

function hideAllFaqs () {
  $('.accordion__section-heading').hide();
  $('.accordion-panel').hide();
}


function performSearch (searchQuery) {

  let searchResultsCount = 0;

  if (searchQuery == '') {
    clearSearch();

  } else {
    hideAllFaqs();
    hideEmptyState();
    $('.results-list').html('');
    $('.results-list').hide();
    $('body').addClass('search-active');

    $('.accordion-toggle .text, .accordion-inner').each(function(index) {
      if ($(this).text().toLowerCase().includes(searchQuery) ||
          $(this).hasClass('accordion-inner') && $(this).attr('data-tags').toLowerCase().includes(searchQuery)) {
        searchResultsCount += 1;
        $('.results-list').append($(this).closest('.accordion-panel').clone());
      }
    });



    if (searchResultsCount == 0) {
      showEmptyState(searchQuery);
    } else {
      $('.results-list').show();
      $('.results-list .accordion-panel').addClass('expanded').show();
    }
  }
}
